//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowUserEmailInMenu: FeatureFlag = {"Id":"ShowUserEmailInMenu","Label":"[10.26]Show user email in the account menu","Impact":"When enabled, a logged-in user's email address is shown as a readonly item at the top of their account dropdown menu, in both the admin and public top navigation. When disabled, the menu is unchanged.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
